Barba.Dispatcher.on('transitionCompleted', function() {
	$('.slider').slick({
	  dots: false,
	  arrows: true,
	  infinite: true,
	  speed: 2000,
	  autoplay: true,
	  fade: true,
	  autoplaySpeed: 2500,
	  pauseOnHover: false
	});

	$('.responsive-slider').slick({
	  dots: false,
	  infinite: true,
	  speed: 300,
	  slidesToShow: 3,
	  slidesToScroll: 3,
	  responsive: [
	    {
	      breakpoint: 800,
	      settings: {
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});
});